module.exports = __webpack_public_path__ + "static/assets/8ae8345a94ca4f682244962e6dc57c21.gif";